<template>
  <div class="flex-start">
    <span v-if="item.icon" class="menu-popup__icon">
      <mdicon v-if="item.loading" name="loading" size="24" class="spinner" />
      <mdicon v-else :name="item.icon" size="24" />
    </span>
    <span class="menu-popup__text"> {{ item.caption }} </span>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>
